var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFoodDeliveryFooter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100pt",
    height: "60pt",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "u",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.4688-0.45312c-0.38672 0.21094-0.78906 0.35938-1.2031 0.45312-0.41797 0.10156-0.85156 0.15625-1.2969 0.15625-1.3555 0-2.4297-0.375-3.2188-1.125-0.79297-0.75781-1.1875-1.7891-1.1875-3.0938 0-1.3008 0.39453-2.3281 1.1875-3.0781 0.78906-0.75781 1.8633-1.1406 3.2188-1.1406 0.44531 0 0.87891 0.054688 1.2969 0.15625 0.41406 0.10547 0.81641 0.25781 1.2031 0.45312v1.6875c-0.38672-0.26953-0.76562-0.46875-1.1406-0.59375s-0.77734-0.1875-1.2031-0.1875c-0.74219 0-1.3281 0.24219-1.7656 0.71875-0.42969 0.48047-0.64062 1.1406-0.64062 1.9844s0.21094 1.5078 0.64062 1.9844c0.4375 0.48047 1.0234 0.71875 1.7656 0.71875 0.42578 0 0.82812-0.0625 1.2031-0.1875s0.75391-0.31641 1.1406-0.57812z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "e",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.4688-4.4375c-0.16797-0.082031-0.33984-0.14062-0.51562-0.17188-0.16797-0.039063-0.33594-0.0625-0.5-0.0625-0.5 0-0.88672 0.16406-1.1562 0.48438-0.27344 0.32422-0.40625 0.78125-0.40625 1.375v2.8125h-1.9531v-6.0938h1.9531v1c0.25-0.40625 0.53516-0.69531 0.85938-0.875 0.32031-0.1875 0.71094-0.28125 1.1719-0.28125 0.0625 0 0.12891 0.007812 0.20312 0.015625 0.082031 0 0.19531 0.011719 0.34375 0.03125z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "b",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.0312-3.0625v0.54688h-4.5625c0.039062 0.46094 0.20312 0.80469 0.48438 1.0312 0.28906 0.23047 0.69141 0.34375 1.2031 0.34375 0.40625 0 0.82031-0.054687 1.25-0.17188 0.4375-0.125 0.87891-0.3125 1.3281-0.5625v1.5c-0.46094 0.17969-0.92188 0.30859-1.3906 0.39062-0.46094 0.09375-0.91797 0.14062-1.375 0.14062-1.1055 0-1.9648-0.28125-2.5781-0.84375-0.60547-0.5625-0.90625-1.3477-0.90625-2.3594 0-0.98828 0.29688-1.7695 0.89062-2.3438 0.60156-0.57031 1.4297-0.85938 2.4844-0.85938 0.95703 0 1.7227 0.29297 2.2969 0.875 0.58203 0.57422 0.875 1.3438 0.875 2.3125zm-2.0156-0.65625c0-0.36328-0.10938-0.66016-0.32812-0.89062-0.21094-0.22656-0.49219-0.34375-0.84375-0.34375-0.375 0-0.68359 0.10938-0.92188 0.32812-0.23047 0.21094-0.375 0.51172-0.4375 0.90625z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "d",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.6719-2.75c-0.40625 0-0.71484 0.074219-0.92188 0.21875-0.19922 0.13672-0.29688 0.33984-0.29688 0.60938 0 0.24219 0.078125 0.43359 0.23438 0.57812 0.16406 0.13672 0.39844 0.20312 0.70312 0.20312 0.36328 0 0.67188-0.12891 0.92188-0.39062 0.25-0.25781 0.375-0.58594 0.375-0.98438v-0.23438zm2.9844-0.73438v3.4844h-1.9688v-0.90625c-0.26172 0.375-0.55859 0.64844-0.89062 0.8125-0.32422 0.16406-0.71875 0.25-1.1875 0.25-0.63672 0-1.1523-0.17969-1.5469-0.54688-0.38672-0.375-0.57812-0.85156-0.57812-1.4375 0-0.71875 0.24219-1.2422 0.73438-1.5781 0.48828-0.33203 1.2578-0.5 2.3125-0.5h1.1562v-0.15625c0-0.30078-0.125-0.52344-0.375-0.67188-0.24219-0.14453-0.61719-0.21875-1.125-0.21875-0.41797 0-0.80859 0.042969-1.1719 0.125-0.36719 0.085937-0.69922 0.21094-1 0.375v-1.4844c0.41406-0.10156 0.83203-0.17969 1.25-0.23438 0.42578-0.050781 0.84766-0.078125 1.2656-0.078125 1.1016 0 1.8984 0.21875 2.3906 0.65625 0.48828 0.42969 0.73438 1.1328 0.73438 2.1094z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "c",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.0625-7.8281v1.7344h2.0156v1.3906h-2.0156v2.5781c0 0.29297 0.054688 0.49219 0.17188 0.59375 0.11328 0.09375 0.33594 0.14062 0.67188 0.14062h1v1.3906h-1.6719c-0.77344 0-1.3203-0.16016-1.6406-0.48438-0.32422-0.32031-0.48438-0.86719-0.48438-1.6406v-2.5781h-0.96875v-1.3906h0.96875v-1.7344z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "k",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.0938-5.2031v-3.2656h1.9531v8.4688h-1.9531v-0.875c-0.27344 0.35547-0.57031 0.61719-0.89062 0.78125-0.32422 0.16406-0.69922 0.25-1.125 0.25-0.75 0-1.3711-0.29688-1.8594-0.89062-0.48047-0.60156-0.71875-1.375-0.71875-2.3125s0.23828-1.7031 0.71875-2.2969c0.48828-0.60156 1.1094-0.90625 1.8594-0.90625 0.41406 0 0.78516 0.089844 1.1094 0.26562 0.33203 0.16797 0.63281 0.42969 0.90625 0.78125zm-1.2969 3.9375c0.41406 0 0.73438-0.14844 0.95312-0.45312 0.22656-0.30078 0.34375-0.74219 0.34375-1.3281 0-0.58203-0.11719-1.0234-0.34375-1.3281-0.21875-0.30078-0.53906-0.45312-0.95312-0.45312-0.40625 0-0.72656 0.15234-0.95312 0.45312-0.21875 0.30469-0.32812 0.74609-0.32812 1.3281 0 0.58594 0.10938 1.0273 0.32812 1.3281 0.22656 0.30469 0.54688 0.45312 0.95312 0.45312z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "j",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.1875-1.2656c0.41406 0 0.73438-0.14844 0.95312-0.45312 0.21875-0.30078 0.32812-0.74219 0.32812-1.3281 0-0.58203-0.10938-1.0234-0.32812-1.3281-0.21875-0.30078-0.53906-0.45312-0.95312-0.45312-0.41797 0-0.74219 0.15625-0.96875 0.46875-0.21875 0.30469-0.32812 0.74219-0.32812 1.3125 0 0.58594 0.10938 1.0273 0.32812 1.3281 0.22656 0.30469 0.55078 0.45312 0.96875 0.45312zm-1.2969-3.9375c0.26953-0.35156 0.56641-0.61328 0.89062-0.78125 0.32031-0.17578 0.69531-0.26562 1.125-0.26562 0.75 0 1.3633 0.30469 1.8438 0.90625 0.48828 0.59375 0.73438 1.3594 0.73438 2.2969s-0.24609 1.7109-0.73438 2.3125c-0.48047 0.59375-1.0938 0.89062-1.8438 0.89062-0.42969 0-0.80469-0.085938-1.125-0.25-0.32422-0.16406-0.62109-0.42578-0.89062-0.78125v0.875h-1.9531v-8.4688h1.9531z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "g",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.14062-6.0938h1.9531l1.625 4.125 1.4062-4.125h1.9531l-2.5781 6.6719c-0.25 0.67578-0.54688 1.1484-0.89062 1.4219-0.34375 0.26953-0.79688 0.40625-1.3594 0.40625h-1.1406v-1.2812h0.625c0.32031 0 0.55469-0.054688 0.70312-0.15625 0.15625-0.10547 0.27344-0.29297 0.35938-0.5625l0.0625-0.17188z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "i",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.3281-0.60938c-0.52344 0.26172-1.0625 0.45312-1.625 0.57812s-1.1406 0.1875-1.7344 0.1875c-1.3555 0-2.4297-0.375-3.2188-1.125-0.79297-0.75781-1.1875-1.7891-1.1875-3.0938 0-1.3125 0.39844-2.3438 1.2031-3.0938 0.80078-0.75 1.9062-1.125 3.3125-1.125 0.53906 0 1.0547 0.054688 1.5469 0.15625 0.5 0.10547 0.96875 0.25781 1.4062 0.45312v1.6875c-0.44922-0.25781-0.89844-0.45312-1.3438-0.57812-0.44922-0.13281-0.90234-0.20312-1.3594-0.20312-0.83594 0-1.4805 0.23438-1.9375 0.70312-0.44922 0.46875-0.67188 1.1367-0.67188 2 0 0.86719 0.21875 1.5312 0.65625 2s1.0547 0.70312 1.8594 0.70312c0.21875 0 0.42188-0.007813 0.60938-0.03125 0.1875-0.03125 0.35156-0.078125 0.5-0.14062v-1.5781h-1.2812v-1.4062h3.2656z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "f",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.0781-3.7188v3.7188h-1.9688v-2.8438c0-0.53125-0.015625-0.89453-0.046875-1.0938-0.023438-0.19531-0.058594-0.34375-0.10938-0.4375-0.074219-0.125-0.17969-0.22266-0.3125-0.29688-0.13672-0.070313-0.28906-0.10938-0.45312-0.10938-0.40625 0-0.72656 0.16406-0.95312 0.48438-0.23047 0.3125-0.34375 0.74609-0.34375 1.2969v3h-1.9531v-6.0938h1.9531v0.89062c0.28906-0.35156 0.59766-0.61328 0.92188-0.78125 0.33203-0.17578 0.70312-0.26562 1.1094-0.26562 0.69531 0 1.2266 0.21875 1.5938 0.65625 0.375 0.42969 0.5625 1.0547 0.5625 1.875z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "t",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.0312-8.1406h2.0938v2.9688l3.0156-2.9688h2.4375l-3.9219 3.8594 4.3281 4.2812h-2.625l-3.2344-3.2031v3.2031h-2.0938z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "h",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.0781-3.7188v3.7188h-1.9688v-2.8281c0-0.53906-0.015625-0.91016-0.046875-1.1094-0.023438-0.19531-0.058594-0.34375-0.10938-0.4375-0.074219-0.125-0.17969-0.22266-0.3125-0.29688-0.13672-0.070313-0.28906-0.10938-0.45312-0.10938-0.40625 0-0.72656 0.16406-0.95312 0.48438-0.23047 0.3125-0.34375 0.74609-0.34375 1.2969v3h-1.9531v-8.4688h1.9531v3.2656c0.28906-0.35156 0.59766-0.61328 0.92188-0.78125 0.33203-0.17578 0.70312-0.26562 1.1094-0.26562 0.69531 0 1.2266 0.21875 1.5938 0.65625 0.375 0.42969 0.5625 1.0547 0.5625 1.875z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "a",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.8438-4.8594c-0.4375 0-0.77344 0.15625-1 0.46875-0.21875 0.3125-0.32812 0.76172-0.32812 1.3438 0 0.58594 0.10938 1.0312 0.32812 1.3438 0.22656 0.3125 0.5625 0.46875 1 0.46875 0.42578 0 0.75-0.15625 0.96875-0.46875 0.22656-0.3125 0.34375-0.75781 0.34375-1.3438 0-0.58203-0.11719-1.0312-0.34375-1.3438-0.21875-0.3125-0.54297-0.46875-0.96875-0.46875zm0-1.3906c1.0508 0 1.8672 0.28906 2.4531 0.85938 0.59375 0.5625 0.89062 1.3438 0.89062 2.3438s-0.29688 1.7891-0.89062 2.3594c-0.58594 0.5625-1.4023 0.84375-2.4531 0.84375-1.0547 0-1.875-0.28125-2.4688-0.84375-0.59375-0.57031-0.89062-1.3594-0.89062-2.3594s0.29688-1.7812 0.89062-2.3438c0.59375-0.57031 1.4141-0.85938 2.4688-0.85938z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "s",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.0312-8.1406h2.0938v6.5625h3.6719v1.5781h-5.7656z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "r",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.9531-8.4688v1.2656h-1.0781c-0.28125 0-0.48047 0.054687-0.59375 0.15625-0.10547 0.10547-0.15625 0.27734-0.15625 0.51562v0.4375h1.6719v1.3906h-1.6719v4.7031h-1.9375v-4.7031h-0.96875v-1.3906h0.96875v-0.4375c0-0.65625 0.17969-1.1406 0.54688-1.4531 0.375-0.32031 0.94531-0.48438 1.7188-0.48438z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "q",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.5938-5.0938c0.25-0.375 0.53906-0.66016 0.875-0.85938 0.34375-0.19531 0.71875-0.29688 1.125-0.29688 0.69531 0 1.2266 0.21875 1.5938 0.65625 0.375 0.42969 0.5625 1.0547 0.5625 1.875v3.7188h-1.9688v-3.1875-0.14062c0.007812-0.050781 0.015625-0.125 0.015625-0.21875 0-0.42578-0.070313-0.73828-0.20312-0.9375-0.125-0.19531-0.32812-0.29688-0.60938-0.29688-0.36719 0-0.65234 0.15625-0.85938 0.46875-0.19922 0.30469-0.30469 0.74219-0.3125 1.3125v3h-1.9531v-3.1875c0-0.66406-0.0625-1.0977-0.1875-1.2969-0.11719-0.19531-0.32031-0.29688-0.60938-0.29688-0.375 0-0.66797 0.15625-0.875 0.46875-0.19922 0.30469-0.29688 0.74219-0.29688 1.3125v3h-1.9688v-6.0938h1.9688v0.89062c0.23828-0.34375 0.50781-0.60156 0.8125-0.78125 0.3125-0.17578 0.65625-0.26562 1.0312-0.26562 0.42578 0 0.80078 0.10547 1.125 0.3125 0.32031 0.19922 0.56641 0.48047 0.73438 0.84375z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "p",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.0312-8.1406h2.3281l2.9688 5.5781v-5.5781h1.9844v8.1406h-2.3438l-2.9531-5.5781v5.5781h-1.9844z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "o",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.875-2.375v-3.7188h1.9531v0.60938 1.2344 1c0 0.49219 0.007813 0.84375 0.03125 1.0625 0.019531 0.21875 0.0625 0.375 0.125 0.46875 0.082031 0.125 0.1875 0.22656 0.3125 0.29688 0.13281 0.074219 0.28516 0.10938 0.45312 0.10938 0.40625 0 0.72266-0.15625 0.95312-0.46875 0.23828-0.3125 0.35938-0.75 0.35938-1.3125v-3h1.9375v6.0938h-1.9375v-0.875c-0.30469 0.35547-0.62109 0.61719-0.95312 0.78125-0.32422 0.16406-0.68359 0.25-1.0781 0.25-0.69922 0-1.2344-0.21094-1.6094-0.64062-0.36719-0.4375-0.54688-1.0664-0.54688-1.8906z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "n",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.0312-8.1406h3.4688c1.0391 0 1.8359 0.23438 2.3906 0.70312 0.55078 0.46094 0.82812 1.1094 0.82812 1.9531 0 0.85547-0.27734 1.5117-0.82812 1.9688-0.55469 0.46094-1.3516 0.6875-2.3906 0.6875h-1.375v2.8281h-2.0938zm2.0938 1.5312v2.2656h1.1562c0.40625 0 0.71875-0.097656 0.9375-0.29688 0.22656-0.19531 0.34375-0.47656 0.34375-0.84375 0-0.36328-0.11719-0.64062-0.34375-0.82812-0.21875-0.19531-0.53125-0.29688-0.9375-0.29688z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "m",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.9375-6.0938h1.9531v5.9844c0 0.8125-0.19922 1.4297-0.59375 1.8594-0.39844 0.4375-0.96484 0.65625-1.7031 0.65625h-0.96875v-1.2812h0.34375c0.36328 0 0.61328-0.085938 0.75-0.25 0.14453-0.16797 0.21875-0.49609 0.21875-0.98438zm0-2.375h1.9531v1.5781h-1.9531z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "l",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.8594-5.9062v1.5938c-0.26172-0.1875-0.52734-0.32031-0.79688-0.40625-0.26172-0.09375-0.53906-0.14062-0.82812-0.14062-0.54297 0-0.96484 0.16406-1.2656 0.48438-0.30469 0.3125-0.45312 0.75781-0.45312 1.3281 0 0.57422 0.14844 1.0234 0.45312 1.3438 0.30078 0.3125 0.72266 0.46875 1.2656 0.46875 0.3125 0 0.60156-0.046875 0.875-0.14062 0.26953-0.09375 0.51953-0.22656 0.75-0.40625v1.5938c-0.30469 0.11719-0.60938 0.19531-0.92188 0.25-0.3125 0.0625-0.625 0.09375-0.9375 0.09375-1.1055 0-1.9688-0.28125-2.5938-0.84375-0.61719-0.5625-0.92188-1.3477-0.92188-2.3594 0-1 0.30469-1.7812 0.92188-2.3438 0.625-0.57031 1.4883-0.85938 2.5938-0.85938 0.3125 0 0.625 0.03125 0.9375 0.09375 0.3125 0.054688 0.61719 0.13672 0.92188 0.25z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m466.78 306.8 41.82 121.97c9.5273-10.414 21.566-18.324 35.301-22.984 8.8359-2.9922 18.008-4.5117 27.254-4.5117 29.469 0 56.254 15.191 71.586 39.277 9.1211-0.4375 11.453-5.7812-3.2031-24.883-23.645-30.809-56.527-36.777-79.656-36.469-1.4531-3.9141-2.9531-8.0039-4.5156-12.324-14.176-39.188-46.004-57.855-64.738-65.746l-18.059-52.668c-1.0898-3.1719-3.3945-5.7266-6.4375-7.125-0.80469-0.37109-1.6367-0.63672-2.4844-0.82422 2.4414 19.473 3.4844 41.535 3.1328 66.285z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m230.07 194.27v-17.551c0-7.1914-5.8281-13.02-13.02-13.02h-154.09c-7.1875 0-13.016 5.832-13.016 13.023v151.92c0 7.1914 5.8281 13.02 13.016 13.02h154.09c0.41406 0 0.82031-0.023437 1.2227-0.0625-0.003907-0.039062-0.007813-0.074218-0.011719-0.11328-3.7266-63.629 0.15625-112.38 11.809-147.22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.7 448.61c10.043-20.328 27.391-35.543 48.859-42.816 8.8398-3 18.008-4.5117 27.266-4.5117 22.223 0 42.906 8.6484 58.316 23.227v-59.805c-4.8594 3.6445-10.68 5.7891-16.879 6.1523-0.58594 0.035157-1.2148 0.050782-1.8398 0.050782-11.73 0-22.008-6.5352-27.34-16.23h-111.7c-5.3906 0-9.7578 4.375-9.7578 9.7617v26.836c0 5.3906 4.3672 9.7578 9.7578 9.7578h1.0781c-10.598 26.004-26.957 71.086-26.957 101.66h42.066c-3.6602-18.258-1.2461-37.105 7.1328-54.078z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268.14 442.79c-18.309-24.625-51.035-35.84-81.668-25.453-38.016 12.887-58.383 54.156-45.492 92.172s54.152 58.387 92.172 45.5c14.539-4.9297 26.484-14.02 34.984-25.48v-86.738zm-49.105 70.574c-15.016 5.0977-31.32-2.957-36.414-17.973-5.0898-15.023 2.957-31.328 17.973-36.414 15.023-5.0898 31.324 2.957 36.418 17.973 5.0898 15.016-2.957 31.32-17.977 36.414z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m533.41 222.62c-20.547 0-37.203 16.652-37.203 37.203s16.656 37.203 37.203 37.203c20.543 0.003906 20.543-74.406 0-74.406z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m487.22 473.41h-71.621v29.273h72.309c-1.9453-9.7109-2.1719-19.59-0.6875-29.273z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m547.82 417.34c-38.016 12.887-58.387 54.156-45.496 92.172 12.887 38.016 54.156 58.387 92.176 45.5 38.016-12.895 58.387-54.16 45.496-92.176-12.891-38.02-54.16-58.391-92.176-45.496zm32.559 96.027c-15.023 5.0977-31.328-2.957-36.418-17.973-5.0859-15.023 2.957-31.328 17.973-36.414 15.023-5.0898 31.324 2.957 36.418 17.973s-2.9531 31.32-17.973 36.414z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402.21 313.77v-10.109h-120.68v228.75c0 15.238 12.352 27.582 27.582 27.582 15.234 0 27.586-12.344 27.586-27.582v-201.4h10.34v201.4c0 15.238 12.352 27.582 27.582 27.582 15.234 0 27.586-12.344 27.586-27.582z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m341.87 192.3c20.859 0 34.984-37.195 38.758-48.359h-77.512c3.7695 11.164 17.895 48.359 38.754 48.359z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402.21 256.57v-58.734c9.3047 19.02 19.07 58.754 14.273 140.79-0.57422 9.8398 6.9336 18.285 16.777 18.859 0.35547 0.023437 0.70312 0.03125 1.0586 0.03125 9.3789 0 17.242-7.3203 17.801-16.809 5.5117-94.258-6.2773-155.75-35.043-182.78-8.7344-8.207-17.316-11.664-23.848-13.059-2.3789 15.805-9.4492 74.266 8.9805 111.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267.26 338.62c-4.5859-78.398 4.2969-120.19 14.27-140.93v58.867c18.422-37.43 11.355-95.887 8.9766-111.69-6.5312 1.3945-15.113 4.8516-23.848 13.055-28.762 27.023-40.551 88.523-35.035 182.78 0.55469 9.4883 8.4219 16.809 17.801 16.809 0.35156 0 0.70312-0.007813 1.0586-0.03125 9.8438-0.57812 17.355-9.0234 16.777-18.859z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m341.87 40.906c27.172 0 44.863 11.16 49.215 30.32 1.3594-4.4258 2.1055-9.3828 2.1055-14.93 0-31.098-22.973-56.301-51.316-56.301-28.34 0-51.316 25.203-51.316 56.301 0 5.5391 0.74219 10.496 2.1016 14.918 4.3555-19.152 22.043-30.309 49.211-30.309z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.05 85.039c0-25.512-20.672-35.922-46.184-35.922-25.504 0-46.184 10.41-46.184 35.922 0 25.504 20.676 46.184 46.184 46.184 25.512 0 46.184-20.676 46.184-46.184z"
  }), /*#__PURE__*/React.createElement("use", {
    x: 49.941406,
    y: 593.464844,
    xlinkHref: "#u"
  }), /*#__PURE__*/React.createElement("use", {
    x: 58.128906,
    y: 593.464844,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 63.628906,
    y: 593.464844,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 71.195312,
    y: 593.464844,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 78.722656,
    y: 593.464844,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 84.054688,
    y: 593.464844,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 91.621094,
    y: 593.464844,
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("use", {
    x: 103.492188,
    y: 593.464844,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("use", {
    x: 111.476562,
    y: 593.464844,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    x: 122.632812,
    y: 593.464844,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("use", {
    x: 131.789062,
    y: 593.464844,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 139.316406,
    y: 593.464844,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 151.140625,
    y: 593.464844,
    xlinkHref: "#t"
  }), /*#__PURE__*/React.createElement("use", {
    x: 159.785156,
    y: 593.464844,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    x: 167.726562,
    y: 593.464844,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 175.390625,
    y: 593.464844,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 183.054688,
    y: 593.464844,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 194.878906,
    y: 593.464844,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("use", {
    x: 201.988281,
    y: 593.464844,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 209.515625,
    y: 593.464844,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    x: 49.941406,
    y: 604.621094,
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("use", {
    x: 54.792969,
    y: 604.621094,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 60.296875,
    y: 604.621094,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 67.960938,
    y: 604.621094,
    xlinkHref: "#q"
  }), /*#__PURE__*/React.createElement("use", {
    x: 83.46875,
    y: 604.621094,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 88.800781,
    y: 604.621094,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    x: 96.742188,
    y: 604.621094,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 108.191406,
    y: 604.621094,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 117.527344,
    y: 604.621094,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 125.191406,
    y: 604.621094,
    xlinkHref: "#o"
  }), /*#__PURE__*/React.createElement("use", {
    x: 133.132812,
    y: 604.621094,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 144.957031,
    y: 604.621094,
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("use", {
    x: 153.132812,
    y: 604.621094,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 158.636719,
    y: 604.621094,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 166.300781,
    y: 604.621094,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("use", {
    x: 170.125,
    y: 604.621094,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 177.6875,
    y: 604.621094,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("use", {
    x: 184.300781,
    y: 604.621094,
    xlinkHref: "#c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodDeliveryFooter);
export default __webpack_public_path__ + "static/media/food-delivery-footer.58e59f52ec71d573ebac6e78e322850d.svg";
export { ForwardRef as ReactComponent };